export default __webpack_public_path__ + "static/media/4.ac739240.png";